/**
 * Haptic feedback patterns for touch interactions
 * Using Vibration API standard patterns
 */

export const HAPTIC_PATTERNS = {
  light: [10], // Quick tap
  medium: [20], // Button press
  heavy: [30], // Long press trigger
  success: [10, 50, 10], // Success confirmation
  error: [30, 50, 30], // Error/warning
} as const

export type HapticPatterns = typeof HAPTIC_PATTERNS
export type HapticPattern = keyof HapticPatterns
